import React, { memo, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import PageLoading from 'src/components/PageLoading';
import { IRouteProps } from 'src/router/types';
import { canAccessRoute } from 'src/utils/permission';

const RenderRouter = (props: any) => {
  const { routers = [] } = props;
  const routeLoop = (routerList: IRouteProps[]) => {
    if (routerList && routerList.length > 0) {
      const output: React.ReactElement[] = [];
      routerList.forEach((item, index) => {
        const { element: Com, children, ...routeProps } = item as any;
        const thisRouteProps = { ...routeProps };
        const childrenRoutes = children && routeLoop(children);

        if (Com) {
          thisRouteProps.element = (
            <Suspense fallback={<PageLoading tip="页面加载中..." />}>
              <Com />
            </Suspense>
          );
        }

        // route 是否包含 permissionKey / adminType，如是登录信息是否授权
        if (!canAccessRoute(item)) {
          thisRouteProps.element = <Navigate to="/403" replace />;
        }

        output.push(
          <Route key={`${item.path}_${index}`} {...thisRouteProps}>
            {childrenRoutes}
          </Route>,
        );
      });
      return output;
    }
    return null;
  };

  return <Routes>{routeLoop(routers)}</Routes>;
};

const areEqual = () => {
  return false;
};

export default memo(RenderRouter, areEqual);
